import { sanitizePrecision } from './general';

const hexToRgba = (hex: string): [number, number, number] => {
  let value = hex.replace('#', '');

  if (value.length === 3) {
    value = value
      .split('')
      .map((c) => c + c)
      .join('');
  }

  const int = parseInt(value, 16);

  // eslint-disable-next-line no-bitwise
  const r = (int >> 16) & 255;
  // eslint-disable-next-line no-bitwise
  const g = (int >> 8) & 255;
  // eslint-disable-next-line no-bitwise
  const b = int & 255;

  return [r, g, b];
};

const getHexBrightness = (hex: string): number => {
  const [r, g, b] = hexToRgba(hex);
  // http://www.w3.org/TR/AERT#color-contrast
  return sanitizePrecision((r * 299 + g * 587 + b * 114) / 1000);
};

export const isHexDark = (hex: string): boolean => getHexBrightness(hex) < 128;

export const randomHexFromString = (str: string): string => {
  let hash = 0;

  if (str.length === 0) return hash.toString();

  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    // eslint-disable-next-line no-bitwise
    hash &= hash;
  }

  let color = '#';

  for (let j = 0; j < 3; j += 1) {
    // eslint-disable-next-line no-bitwise
    const value = (hash >> (j * 8)) & 255;
    color += `00${value.toString(16)}`.substr(-2);
  }

  return color;
};
